import { Box, TextField, Typography } from "@mui/material";
import React from "react";
import { useParams } from "react-router-dom";

import GroundPrepAPI from "../api/GroundPrep.api";
import BasicShowEdit from "../components/BasicShowEdit";
import Layout from "../components/Layout";
import { GroundPrep, GroundPrepInput } from "../types";

export default function GroundPrepShow() {
  const { id } = useParams();
  const { data: groundPrep } = GroundPrepAPI.useDetail(id);

  return (
    <Layout>
      <Box
        sx={{
          display: "flex",
          flexGrow: 1,
          flexDirection: "column",
          gap: "1rem",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
          }}
        >
          <Typography variant="h2">Ground Prepping</Typography>
        </Box>

        {groundPrep && <GroundPrepForm groundPrep={groundPrep} />}
      </Box>
    </Layout>
  );
}

function GroundPrepForm({ groundPrep }: { groundPrep: GroundPrep }) {
  const [name, setName] = React.useState<string>(groundPrep.name);

  const input: GroundPrepInput = {
    ...groundPrep,
    name,
  };

  return (
    <BasicShowEdit
      modelApiUseSave={GroundPrepAPI.useSave}
      modelApiUseDelete={GroundPrepAPI.useDelete}
      modelInput={input}
    >
      <TextField
        label="Name"
        value={name}
        onChange={(event) => setName(event.target.value)}
      />
    </BasicShowEdit>
  );
}
